import axios from 'axios';
import router from "@/router";
import Swal from 'sweetalert2';
import {getErrorMessage} from "@/utils/ErrorDictionary";

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:8080/api/dietec',
    headers: {
        'Content-Type': 'application/json',
    },
});

let isAlertOpen = false;

// Request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
    (response) => response.data,
    (error) => {
        // No network connection
        if (error.code === 'ERR_NETWORK') {
            if (!isAlertOpen) {
                Swal.fire({
                    toast: true,
                    icon: 'error',
                    titleText: 'Error',
                    text: 'No fue posible conectarse con el servidor.',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000,
                    timerProgressBar: true,
                    background: '#fff',
                    color: '#000',
                    iconColor: '#ff6600',
                    target: '.v-application',
                }).then(r => r);
                return Promise.reject(error);
            }
        }

        // Server error
        if (error.response) {
            const {status, data} = error.response;
            const errorMessage = getErrorMessage(data);

            // No permissions
            if (status === 403) {
                if (isAlertOpen) return Promise.reject(error);
                isAlertOpen = true;
                Swal.fire({
                    icon: 'warning',
                    titleText: 'Acceso denegado',
                    text: 'No tienes permisos para acceder a este recurso.',
                    showConfirmButton: false,
                    timer: 2500,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    allowEnterKey: false,
                    background: '#fff',
                    color: '#000',
                    iconColor: '#ff6600',
                    timerProgressBar: true,
                    target: '.v-application',
                }).then(r => {
                    isAlertOpen = false;
                    router.push({name: 'Home'}).catch(() => {
                    });
                });
                return Promise.reject(error);
            }

            // Unauthorized
            if (status === 401) {
                if (isAlertOpen) return Promise.reject(error);
                isAlertOpen = true;
                Swal.fire({
                    icon: 'warning',
                    titleText: 'Sesión expirada',
                    text: 'Por favor inicia sesión nuevamente.',
                    showConfirmButton: false,
                    timer: 4000,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    allowEnterKey: false,
                    background: '#fff',
                    color: '#000',
                    iconColor: '#ff6600',
                    timerProgressBar: true,
                    target: '.v-application',
                }).then(r => {
                    isAlertOpen = false;
                    localStorage.removeItem('token');
                    window.location.href = '/login';
                    window.location.reload();
                });
                return Promise.reject(error);
            }

            // Show error message
            Swal.fire({
                toast: true,
                icon: 'error',
                titleText: 'Error',
                text: errorMessage,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                background: '#fff',
                color: '#000',
                iconColor: '#ff6600',
                target: '.v-application',
            }).then(r => r);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;